import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {PipeModule} from '../_pipe/pipe.module';
import {FormsModule} from '@angular/forms';
import {ChartModule} from 'angular2-highcharts';
import {HighchartsStatic} from 'angular2-highcharts/dist/HighchartsService';
import {TabsModule} from 'ngx-bootstrap/tabs'; 
// import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ChartsModule} from 'ng2-charts/ng2-charts';
import { ExportCanvasComponent } from './export-canvas.component';

const Highcharts = require('highcharts');

Highcharts.setOptions({
  global: {
    // timezoneOffset: 7 * 60,
    useUTC: true
  }
});

export function highchartsFactory() {
  const hc = require('highcharts');
  const dd = require('highcharts/modules/exporting');
  dd(hc);
  return hc;
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PipeModule.forRoot(),
    TabsModule.forRoot(),
    ChartModule,
    ChartsModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    PipeModule,
    ChartModule,
    ChartsModule,
    ExportCanvasComponent
  ],
  declarations: [
    ExportCanvasComponent
  ],
  providers: [{
    provide: HighchartsStatic,
    useFactory: highchartsFactory
  }]
})
export class SharedModule { }



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_shared/shared.module.ts